module.exports = __webpack_public_path__ + "static/media/thiago_dos_santos.38ee96a5.jpg";